module.exports = __webpack_public_path__ + "img/ECV_logo_WHT.2b2166b3.svg";